import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProjectPlanModel } from '../models/project-plan.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectPlanService {
  private planDataSource = new BehaviorSubject<ProjectPlanModel | null>(null);
  planData$ = this.planDataSource.asObservable();

  constructor() {}

  setPlanData(data: ProjectPlanModel): void {
    this.planDataSource.next(data);
  }

  clearPlanData(): void {
    this.planDataSource.next(null);
  }
  
}
